import type { ReactNode } from 'react';

type PageHeaderProperties = {
  actions?: ReactNode;
  description?: ReactNode;
  eyebrow?: ReactNode;
  title: ReactNode;
};

export const PageHeader = ({ actions, description, eyebrow, title }: PageHeaderProperties) => (
  <div className="flex flex-wrap items-start justify-between gap-3">
    <div>
      {eyebrow ? <p className="text-muted text-xs font-semibold tracking-wide uppercase">{eyebrow}</p> : null}
      <h1 className="text-ink text-xl font-semibold tracking-[-0.025em]">{title}</h1>
      {description ? <div className="text-muted mt-1 max-w-3xl text-sm">{description}</div> : null}
    </div>
    {actions ? <div className="flex flex-wrap items-center gap-2">{actions}</div> : null}
  </div>
);
